import { render, staticRenderFns } from "./MuseumModal.vue?vue&type=template&id=354c9a7c&"
import script from "./MuseumModal.vue?vue&type=script&lang=js&"
export * from "./MuseumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports